module.exports = __webpack_public_path__ + "img/gplay.21c46fb9.svg";